<template>
  <div class="swiper-card">
    <div class="game-bg"></div>
    <div class="corner-radius-blur newsle"></div>
    <div class="confetti"></div>

    <div class="game-content">
      <h1>Five To Thrive</h1>
      <p>Five questions, fresh news, and a little friendly challenge — how many can you get right today?</p>
      <button @click="startPlaying()">Let's Play</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    methods: {
      startPlaying() {
        this.EventBus.$emit('swiper:next')
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  $border-radius: 15px;
  $purple: #9000D4;
  $white: #fff;
  $purple-faded-bg: rgba(144, 0, 212, 0.2);
  $purple-box-shadow: 0px 4px 0px rgba(144, 0, 212, 0.4), 0px 0px 150px rgba(144, 0, 212, 0.1);
  $yellow-box-shadow: 0px 4px 0px rgba(249, 222, 75, 0.4), 0px 0px 150px rgba(249, 222, 75, 0.1);

  .game-bg {
    background: linear-gradient(180deg, #03132F 0%, rgba(144, 0, 212, 0.5) 99.99%);
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 0;
  }

  .game-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    padding-top: 6rem;
    z-index: 10;
  }

  h1 {
    font-family: 'Creighton' !important;
    font-size: 60px !important;
    line-height: 100%;
    font-weight: normal;
    text-wrap: balance;
  }

  p {
    font-size: 20px;
    line-height: 150%;
    text-wrap: balance;
  }

  button {
    border-radius: $border-radius;
    box-shadow: $yellow-box-shadow;
    margin-top: 1rem;

    &:disabled {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .confetti {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10rem;
    min-width: 500px;
    z-index: 0;
    background-image: url('@assets/images/onboarding-confetti.png');
    background-size: cover;
    background-position: bottom;

    .desktop & {
      height: 15rem;
    }
  }
</style>